import React from 'react';

import Chat from '../pages/Chat';
import Clients from '../pages/ClientsPage/ClientsPage';
import { InvoicingPage } from '../pages/InvoicingPage';
import { ResourcesPage } from '../pages/ResourcesPage';
import SessionsPage from '../pages/SessionsPage';
import Settings from '../pages/Settings';
import VideoPage from '../pages/VideoPage';
import ProtectedRoute from '../components/ProtectedRoute';
import { NewInvoicingPage } from '../pages/NewInvoicingPage';

export enum AppRouteTestID {
  InvoicingRoutes = 'invoicing-routes',
  FullAccessRoutes = 'full-access-routes',
}

export const getRoutes = (isInvoicingTherapist: boolean) => {
  return (
    <>
      {isInvoicingTherapist && (
        <div data-testid={AppRouteTestID.InvoicingRoutes}>
          <ProtectedRoute
            path="/invoicing"
            component={InvoicingPage}
            analytics={{
              pageName: 'invoicing',
            }}
          />
        </div>
      )}

      {!isInvoicingTherapist && (
        <div data-testid={AppRouteTestID.FullAccessRoutes}>
          <ProtectedRoute
            path="/sessions"
            component={SessionsPage}
            analytics={{
              pageName: 'sessions',
            }}
          />
          <ProtectedRoute
            path="/resources"
            component={ResourcesPage}
            analytics={{
              pageName: 'resources',
            }}
          />
          <ProtectedRoute
            path="/clients/:memberUuid?"
            component={Clients}
            analytics={{
              pageName: 'clients',
            }}
          />
          <ProtectedRoute
            path="/chat/:conversationUuid?"
            component={Chat}
            analytics={{
              pageName: 'chat',
            }}
          />
          <ProtectedRoute
            path="/video-session/:visitUuid"
            component={VideoPage}
            analytics={{
              pageName: 'video',
            }}
          />
          <ProtectedRoute
            path="/settings"
            component={Settings}
            analytics={{
              pageName: 'settings',
            }}
          />
          <ProtectedRoute
            path="/invoicing"
            component={NewInvoicingPage}
            analytics={{
              pageName: 'new-invoicing',
            }}
          />
        </div>
      )}
    </>
  );
};
